import React, { Fragment } from 'react'

export default function CheckPoints() {

    const points = [{
        text: "Your Social Security number"
    },
    {
        text: "A government issued drivers license or photo ID",
    },
    {
        text: "Check points for loan app Your checking account number",
    },
    {
        text: "Your bank's routing number",
    },
    {
        text: "Be at least 18 years of age",
    },
    {
        text: "Proof of income",
    },
    ]
  return (
    <Fragment>
        <div>
            {
                points.map((item, index)=>{
                    return(
                        <p key={`check-${index}`}>
                            <img 
                                width="24px" 
                                height="24px" 
                                alt="Check points for loan app" 
                                src="https://local.checkintocash.com/wp-content/plugins/cic-theme-assets/assets/img/starburst-check.png" 
                            />  
                            <strong>{item.text}</strong>
                        </p>
                    )
                })
            }
        </div>
    </Fragment>
  )
}
